import {
    SET_USER_DATA_START,
    SET_USER_DATA_SUCCESS,
    USER_LOGOUT_SUCCESS
  } from '../constants';
  
  export default function userAccount(state = {}, action) {
    switch (action.type) {
      case SET_USER_DATA_START:
        return {
          ...state,
        };
      case SET_USER_DATA_SUCCESS:
        return {
          ...state,
          data: action.profileData,
        };
      case USER_LOGOUT_SUCCESS:
        return {
          ...state,
          data: null
        };
  
      default:
        return state;
    }
  }
  